(function () {
  if (window.__AG_PB_CLINICAL_TRIAL_INIT__) return;
  window.__AG_PB_CLINICAL_TRIAL_INIT__ = true;

  var DURATION_MS = 1200;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function clampPercent(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return 0;
    return Math.max(0, Math.min(100, n));
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateStat(stat) {
    if (stat.dataset.agPbClinicalAnimated === 'true') return;
    stat.dataset.agPbClinicalAnimated = 'true';

    var target = clampPercent(stat.getAttribute('data-percent'));
    var rings = stat.querySelectorAll('.js-ag-pb-clinical-ring');
    var reflexes = stat.querySelectorAll('.js-ag-pb-clinical-reflex');
    var label = stat.querySelector('.js-ag-pb-clinical-percent');

    function setReflex(value) {
      for (var i = 0; i < reflexes.length; i++) {
        var el = reflexes[i];
        var mode = el.getAttribute('data-reflex-mode') || 'start';
        var len = parseFloat(el.getAttribute('data-reflex-len'));
        if (isNaN(len) || len <= 0) len = 8;

        var offset = 0;
        var visible = 0;

        if (mode === 'tip') {
          // Optional inset pulls accent back from leading tip
          var inset = parseFloat(el.getAttribute('data-reflex-inset'));
          if (isNaN(inset) || inset < 0) inset = 0;
          var tipEnd = Math.max(0, value - inset);
          visible = Math.min(len, tipEnd);
          offset = Math.max(0, tipEnd - visible);
        } else if (mode === 'mid') {
          var ratio = parseFloat(el.getAttribute('data-reflex-ratio'));
          if (isNaN(ratio)) ratio = 0.4;
          var center = value * ratio;
          offset = Math.max(0, center - len / 2);
          visible = Math.max(0, Math.min(len, value - offset));
        } else {
          // start / fixed — clipped to current fill
          offset = parseFloat(el.getAttribute('data-reflex-offset'));
          if (isNaN(offset)) offset = 0;
          visible = Math.max(0, Math.min(len, value - offset));
        }

        el.setAttribute('stroke-dasharray', visible + ' ' + (100 - visible));
        el.setAttribute('stroke-dashoffset', String(-offset));
      }
    }

    function setRing(value) {
      // pathLength=100; dash = filled portion, gap = remainder (empty top-right in Figma)
      var dash = value + ' ' + (100 - value);
      for (var i = 0; i < rings.length; i++) {
        rings[i].setAttribute('stroke-dasharray', dash);
        rings[i].setAttribute('stroke-dashoffset', '0');
      }
      setReflex(value);
    }

    if (prefersReducedMotion()) {
      setRing(target);
      if (label) label.textContent = String(Math.round(target));
      return;
    }

    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var progress = Math.min(1, (ts - start) / DURATION_MS);
      var eased = easeOutCubic(progress);
      var current = target * eased;

      setRing(current);
      if (label) label.textContent = String(Math.round(current));

      if (progress < 1) {
        window.requestAnimationFrame(frame);
      } else {
        setRing(target);
        if (label) label.textContent = String(Math.round(target));
      }
    }

    window.requestAnimationFrame(frame);
  }

  function initBlock(root) {
    if (root.dataset.agPbClinicalReady === 'true') return;
    root.dataset.agPbClinicalReady = 'true';

    var stats = root.querySelectorAll('.js-ag-pb-clinical-stat');
    if (!stats.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(stats, animateStat);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateStat(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35, rootMargin: '0px 0px -8% 0px' }
    );

    Array.prototype.forEach.call(stats, function (stat) {
      observer.observe(stat);
    });
  }

  function initAll() {
    document
      .querySelectorAll('.js-ag-pb-clinical-trial, .js-ag-pb-clinical-trial-alt, .js-ag-pb-clinical-result')
      .forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.querySelectorAll) {
      initAll();
      return;
    }
    section
      .querySelectorAll('.js-ag-pb-clinical-trial, .js-ag-pb-clinical-trial-alt, .js-ag-pb-clinical-result')
      .forEach(function (root) {
        root.dataset.agPbClinicalReady = '';
        root.querySelectorAll('.js-ag-pb-clinical-stat').forEach(function (stat) {
          stat.dataset.agPbClinicalAnimated = '';
        });
        initBlock(root);
      });
  });
  document.addEventListener('shopify:block:select', initAll);
})();
